import React, { useContext, useEffect } from 'react';
import PdfReport from '@/pages/home/components/Pdf';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';

const Pdf = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);
  const url = currentMenu?.url || '';
  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '800601',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/pdf/report/${nameEn || ''}`,
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);

  return (<>{url && <PdfReport url={url} />}</>);
};

export default Pdf;